import React, { useState } from 'react';
import axios from 'axios';
import PageHero from '../components/PageHero';
import { IconMapPin, IconPhone, IconMail, IconClock } from '../components/Icons';
import './Contact.css';

const SERVICE_OPTIONS = [
  '-- Seleccione un servicio --',
  'Planes de Ventilación',
  'Planes de Sostenimiento',
  'Prevención Metano y Polvo de Carbón',
  'PTO – Plan de Trabajos y Obras',
  'Asesorías Mineras',
  'ICAS – Informe de Cumplimiento Ambiental',
  'Estudios de Aguas',
  'Licencias Ambientales',
  'PMA – Plan de Manejo Ambiental',
  'Otro',
];

const CONTACT_ITEMS = [
  { Icon: IconMapPin, label: 'Sede Principal', value: 'Sogamoso, Boyacá, Colombia' },
  { Icon: IconPhone, label: 'Teléfono', value: '312 376 6296 - 321 416 2832' },
  { Icon: IconMail, label: 'Correo Electrónico', value: 'contacto@impactama.com' },
  { Icon: IconClock, label: 'Horario de Atención', value: 'Lun – Vie: 8:00 AM – 6:00 PM' },
];

const initialForm = { name: '', email: '', phone: '', company: '', service: '', message: '' };

export default function Contact() {
  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState(null);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = 'El nombre es requerido';
    if (!form.email.trim()) e.email = 'El correo es requerido';
    else if (!/\S+@\S+\.\S+/.test(form.email)) e.email = 'Correo inválido';
    if (!form.service || form.service === SERVICE_OPTIONS[0]) e.service = 'Seleccione un servicio';
    if (!form.message.trim()) e.message = 'El mensaje es requerido';
    return e;
  };

  const handleChange = (e) => {
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
    setErrors(err => ({ ...err, [e.target.name]: undefined }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length > 0) { setErrors(errs); return; }
    setStatus('sending');
    try {
      const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
      await axios.post(`${API}/contact/send`, form);
      setStatus('success');
      setForm(initialForm);
    } catch {
      setStatus('error');
    }
  };

  return (
    <div>
      <PageHero
        title="Contáctenos"
        subtitle="Solicite una cotización o consulta. Respondemos en menos de 24 horas hábiles."
        variant="blue"
      />

      <section className="section">
        <div className="container contact-grid">

          {/* Info column */}
          <div className="contact-info">
            <div className="divider" />
            <h2 className="section-title">Información de Contacto</h2>
            <p className="contact-info__lead">
              Estamos ubicados en Sogamoso, Boyacá, y atendemos proyectos a nivel nacional.
            </p>

            <div className="contact-info__cards">
              {CONTACT_ITEMS.map(({ Icon, label, value }) => (
                <div key={label} className="contact-info-card">
                  <div className="contact-info-card__icon">
                    <Icon size={20} />
                  </div>
                  <div>
                    <strong>{label}</strong>
                    <p>{value}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="contact-services-list">
              <h4>Servicios Disponibles</h4>
              <div className="contact-services-tags">
                {['Ventilación', 'Sostenimiento', 'Metano/Polvo', 'PTO', 'ICAS', 'Aguas', 'Licencias', 'PMA'].map(s => (
                  <span key={s} className="tag tag--green">{s}</span>
                ))}
              </div>
            </div>
          </div>

          {/* Form column */}
          <div className="contact-form-wrap">
            <h3>Envíenos su Consulta</h3>
            <p>Complete el formulario y un especialista se comunicará con usted a la brevedad.</p>

            {status === 'success' && (
              <div className="contact-alert contact-alert--success">
                Mensaje enviado exitosamente. Nos comunicaremos pronto.
              </div>
            )}
            {status === 'error' && (
              <div className="contact-alert contact-alert--error">
                Hubo un error al enviar. Por favor intente de nuevo o comuníquese directamente.
              </div>
            )}

            <form className="contact-form" onSubmit={handleSubmit} noValidate>
              <div className="contact-form__row">
                <div className="contact-form__field">
                  <label>Nombre completo *</label>
                  <input
                    type="text"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    placeholder="Su nombre"
                    className={errors.name ? 'input-error' : ''}
                  />
                  {errors.name && <span className="field-error">{errors.name}</span>}
                </div>
                <div className="contact-form__field">
                  <label>Correo electrónico *</label>
                  <input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    placeholder="correo@empresa.com"
                    className={errors.email ? 'input-error' : ''}
                  />
                  {errors.email && <span className="field-error">{errors.email}</span>}
                </div>
              </div>

              <div className="contact-form__row">
                <div className="contact-form__field">
                  <label>Teléfono / WhatsApp</label>
                  <input
                    type="tel"
                    name="phone"
                    value={form.phone}
                    onChange={handleChange}
                    placeholder="+57 300 000 0000"
                  />
                </div>
                <div className="contact-form__field">
                  <label>Empresa / Organización</label>
                  <input
                    type="text"
                    name="company"
                    value={form.company}
                    onChange={handleChange}
                    placeholder="Nombre de su empresa"
                  />
                </div>
              </div>

              <div className="contact-form__field">
                <label>Servicio de interés *</label>
                <select
                  name="service"
                  value={form.service}
                  onChange={handleChange}
                  className={errors.service ? 'input-error' : ''}
                >
                  {SERVICE_OPTIONS.map(o => (
                    <option key={o} value={o === SERVICE_OPTIONS[0] ? '' : o}>{o}</option>
                  ))}
                </select>
                {errors.service && <span className="field-error">{errors.service}</span>}
              </div>

              <div className="contact-form__field">
                <label>Mensaje *</label>
                <textarea
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  placeholder="Describa brevemente su proyecto o consulta..."
                  rows={5}
                  className={errors.message ? 'input-error' : ''}
                />
                {errors.message && <span className="field-error">{errors.message}</span>}
              </div>

              <button
                type="submit"
                className="btn btn--primary contact-submit-btn"
                disabled={status === 'sending'}
              >
                {status === 'sending' ? 'Enviando...' : 'Enviar Consulta'}
              </button>
            </form>
          </div>

        </div>
      </section>
    </div>
  );
}
